﻿import { defineStore } from 'pinia';
import { IPopularLink } from '../../../interfaces/Navigation';

interface IState {
    navigationType: string;
    mobileNavIsOpen: boolean;
    mobileSearchNavIsOpen: boolean;
    popularTopics: IPopularLink[];
}

export const useMobileNavStore = defineStore('mobileNavStore', {
    state: (): IState => {
        return {
            navigationType: '',
            mobileNavIsOpen: false,
            mobileSearchNavIsOpen: false,
            popularTopics: [],
        };
    },
    getters: {
        getNavigationType(state) {
            return state.navigationType;
        },
        getOpendState(state) {
            return state.mobileNavIsOpen;
        },
        getSearchNavState(state) {
            return state.mobileSearchNavIsOpen;
        },
    },
    actions: {
        setPopularTopics(topics: Array<IPopularLink>) {
            this.popularTopics = topics;
        },
        toggleNav(isOpen: boolean) {
            this.mobileNavIsOpen = isOpen;
        },
        toggleSearchNav() {
            this.mobileSearchNavIsOpen = !this.mobileSearchNavIsOpen;
        },
        setNavigationType(type: string) {
            this.navigationType = type;
        },
    },
});
